module.exports = __webpack_public_path__ + "img/maids.467e0623.png";